const gmtExists = (): any => window && (window as any).dataLayer;
export default gmtExists;
